import "./App.css";
import Navbar from "./navbar/navbar";
import Home from "./pages/home/home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import About from "./pages/about/about";
import Certification from "./pages/certification/certification";
import Portfolio from "./pages/portfolio/portfolio";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />}></Route>
          <Route  path="/about" element={<About />}></Route>
          <Route  path="/contact" element={<Certification />}></Route>
          <Route  path="/portfolio" element={<Portfolio />}></Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
